import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './routes';
import history from './history';
import './App.css';

function App() {
  return (
    <div className="App">
      <Router history={history}>
        <Routes />
      </Router>
    </div>
  );
}

export default App;
